// extracted by mini-css-extract-plugin
module.exports = {"richEditorContainer":"styles_richEditorContainer__2SxDk","message":"styles_message__2cA51","extraOptions":"styles_extraOptions__2Op8t","customize":"styles_customize__3Frb0"};